import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { verifyBooking } from 'redux/booking/travel/travelBookingSlice';
import { Modal, Button, Alert } from 'components/common';

const BookingDetailVerifyModal = ({ showModal, setshowModal, booking }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const dispatch = useDispatch();

  const closeModal = () => setshowModal(false);

  const onSubmit = (data) => {
    try {
      dispatch(verifyBooking({ bookingId: booking.id, data }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Verify travel booking"
      size="lg"
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button size="sm" type="submit" form="travel-verify-form" variant="primary">Submit</Button>
        </>
      )}
    >
      <form id="travel-verify-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="warning" className="tw-mb-4">The HR admin at the Head office will verify the overall trip information before sending it for the next approval.</Alert>
        <label className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Note *</label>
        <textarea rows={6} placeholder="Note"
          className="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-slate-300 tw-rounded-md tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          {...register('note', { required: 'Note must be required' })} />
        {errors.note && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{errors.note.message}</p>}
      </form>
    </Modal>
  );
};

BookingDetailVerifyModal.propTypes = {
  showModal: PropTypes.bool,
  setshowModal: PropTypes.func,
  booking: PropTypes.object,
};

export default BookingDetailVerifyModal;
